import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Chip, TableCell, TableRow } from '@mui/material';
import { HTMLAttributes } from 'react';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { DISPLAY_DATE_TIME_FORMAT } from '@/utils/dateHelper';

type Props = {
	item: any;
} & HTMLAttributes<HTMLDivElement>;

const SortableArticlesItem = ({ item }: Props) => {
	const { t } = useTranslation();
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({
		id: item.id,
	});

	const styles = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? '0.4' : '1',
		backgroundColor: isDragging ? '#F5F5F5' : '',
	};
	return (
		<>
			<TableRow ref={setNodeRef} style={styles}>
				<TableCell component='th' scope='row'>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<DehazeIcon cursor={'pointer'} {...listeners} {...attributes} />
						{`${item?.code || '-'}`}
					</Box>
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.nameEn || '-'}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.nameZh || '-'}`}
				</TableCell>

				<TableCell component='th' scope='row'>
					{`${
						!item.updatedAt
							? '-'
							: dayjs(item.updatedAt)
									.locale('en')
									.format(DISPLAY_DATE_TIME_FORMAT)
					}`}
				</TableCell>

				<TableCell component='th' scope='row'>
					<Chip
						color={item?.status === 0 ? 'chipTertiary' : 'chipPrimary'}
						sx={{
							height: 'auto',
							minHeight: '24px',
							maxWidth: '100%',
							overflow: 'hidden',
							whiteSpace: 'normal',
							wordBreak: 'break-word',
							padding: '4px 4px',
						}}
						label={
							<Box
								sx={{
									width: '100%',
									whiteSpace: 'normal',
									wordBreak: 'break-word',
								}}
							>
								{item?.status === 0 ? t('field.active') : t('field.inActive')}
							</Box>
						}
					/>
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${item?.actionedByName || '-'}`}
				</TableCell>
			</TableRow>
		</>
	);
};

export default SortableArticlesItem;
